import * as React from "react";

const HomeIconSVG = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="41" height="40">
    <path
      fill="#D3E205"
      d="M12.5 28.447v-11.25l7.5-5.644 7.5 5.644v11.25h-5.596v-6.692h-3.808v6.692z"
    ></path>
  </svg>
);

export default HomeIconSVG;
